import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import pinia from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import focusable from 'vue-tv-focusable'
import 'lib-flexible/flexible.js'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import VxeTable from 'vxe-table'
import 'vxe-table/lib/style.css'
import { Lazyload } from 'vant';

export const imgBaseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : 'https://peiqisport.club'

const app = createApp(App)
const head = createHead()
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(pinia).use(router).use(ElementPlus).use(focusable).use(VxeTable).use(Lazyload).use(head).mount('#app')
